export const getGroupList = function () {
  let promise = tim.getGroupList();
  promise.then(function (imResponse) {
  }).catch(function (imError) {
    console.warn('getGroupList error:', imError); // 获取群组列表失败的相关信息
  });
}

export const getConversationList = function () {
  // 拉取会话列表
  let promise = tim.getConversationList();
  promise.then(imResponse => {
    const list = imResponse.data.conversationList; // 会话列表，用该列表覆盖原有的会话列表
    if (Array.isArray(list)) {
      let C2CAvatar = store.state.defaultAvatar.C2C;
      let groupAvatar = store.state.defaultAvatar.GROUP;
      let myContacts = store.getters.contactsList;
      let session = [];
      list.forEach((item) => {
        let messageForShow = item.lastMessage.messageForShow;
        if (item.lastMessage.type === TIM.TYPES.MSG_CUSTOM) {
          messageForShow = item.lastMessage.payload.description;
        }
        switch (item.type) {
          case "C2C":
            let displayName = item.userProfile.nick;
            let thisFriend = myContacts.filter(contact => {
              return contact.userId == item.userProfile.userID
            });
            if (thisFriend.length != 0 && thisFriend[0].markInfo) {
              if (thisFriend[0].markInfo.mark != "") {
                displayName = thisFriend[0].markInfo.mark
              }
            }
            session.push(
              {
                avatar: item.userProfile.avatar == "" ? C2CAvatar : item.userProfile.avatar,
                name: displayName,
                lastMessage: messageForShow,
                lastTime: formatMsgTimeStamp(item.lastMessage.lastTime),
                sessionId: item.conversationID,
                type: item.type,
                unreadCount: item.unreadCount,
                userId: item.userProfile.userID
              }
            );
            break;
          case "GROUP":
            session.push(
              {
                avatar: groupAvatar,
                name: item.groupProfile.name,
                lastMessage: messageForShow,
                lastTime: formatMsgTimeStamp(item.lastMessage.lastTime),
                sessionId: item.conversationID,
                type: item.type,
                unreadCount: item.unreadCount,
                userId: item.groupProfile.groupID
              }
            );
            break;
          default:
            break;
        }
      });

      store.dispatch("setConversationList", session);

    }
  }).catch(function (imError) {
    console.warn('getConversationList error:', imError); // 获取会话列表失败的相关信息
  });
}

export const formatMsgTimeStamp = function (timestamp) {
  function zeroize(num) {
    return (String(num).length == 1 ? '0' : '') + num;
  }
  var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
  var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
  var tmDate = new Date(timestamp * 1000);  // 参数时间戳转换成的日期对象

  var Y = tmDate.getFullYear(), m = tmDate.getMonth() + 1, d = tmDate.getDate();
  var H = tmDate.getHours(), i = tmDate.getMinutes(), s = tmDate.getSeconds();

  if (curDate.getFullYear() == Y && curDate.getMonth() + 1 == m && curDate.getDate() == d) {
    return zeroize(H) + ':' + zeroize(i);
  } else {
    var newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
    if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
      return '昨天 ' + zeroize(H) + ':' + zeroize(i);
    } else if (curDate.getFullYear() == Y) {
      return zeroize(m) + '-' + zeroize(d) + ' ' + zeroize(H) + ':' + zeroize(i);
    } else {
      return Y + '-' + zeroize(m) + '-' + zeroize(d) + ' ' + zeroize(H) + ':' + zeroize(i);
    }
  }
}